module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "cyan darken-3",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Documentos")])], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.documents), function(document) {
    return _c('v-list-tile', {
      key: document.name,
      on: {
        "click": function($event) {
          return _vm.genTokenAndDownload(document)
        }
      }
    }, [_c('v-list-tile-action', [(document.type != 'ata' || document.url) ? _c('v-icon', {
      attrs: {
        "color": "success"
      }
    }, [_vm._v("file_download")]) : _c('v-icon', {
      attrs: {
        "color": "info"
      }
    }, [_vm._v("add")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('div', {
      staticClass: "body-1"
    }, [_vm._v("\n                    " + _vm._s(document.name) + "\n                    "), (document.params.role) ? _c('v-chip', {
      staticClass: "cyan darken-3 white--text",
      attrs: {
        "label": "",
        "small": ""
      }
    }, [_vm._v(_vm._s(document.params.role))]) : _vm._e()], 1)])], 1)
  }), 1), _vm._v(" "), (_vm.showMinutesConfirmation) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "info darken-3",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Ata da Banca")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showMinutesConfirmation = false
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n                As informações da banca "), _c('strong', {
    staticClass: "red--text"
  }, [_vm._v("não poderão")]), _vm._v(" ser alteradas após a emissão da ata.\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "info"
    },
    on: {
      "click": _vm.previewMinutes
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("pageview")]), _vm._v(" Pré-visualizar\n                ")], 1), _vm._v(" "), (_vm.previewURL) ? _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "info"
    },
    on: {
      "click": function($event) {
        return _vm.openURL(_vm.previewURL)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("refresh")]), _vm._v(" Clique aqui caso a pré-visualização da ata não tenha sido exibida\n                ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "dark": "",
      "color": "success"
    },
    on: {
      "click": _vm.generateMinutes
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("check")]), _vm._v(" Emitir\n                ")], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.errors != false) ? _c('v-card-title', _vm._l((_vm.errors), function(error, idx) {
    return _c('v-alert', {
      key: 'error_' + idx,
      attrs: {
        "color": "error",
        "value": "true"
      }
    }, [_vm._v("\n            " + _vm._s(error) + "\n        ")])
  }), 1) : _vm._e(), _vm._v(" "), (_vm.showActions) ? _c('v-card-actions', [_vm._t("actions")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-792b7588"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamDocuments.vue
// module id = 254
// module chunks = 0